export const GCP_HOSTING_DEPLOY_AI_LOG_STEPS = [
  {
    durationMs: 2000,
    actionName: 'Enabled GCP APIs',
    arguments: {
      command: 'gcloud services enable run.googleapis.com sqladmin.googleapis.com compute.googleapis.com',
    },
    result: { ok: true },
    status: 'ok',
    stepNarration: 'Cloud Run, Cloud SQL, and Compute APIs are enabled on the project.',
  },
  {
    durationMs: 8400,
    actionName: 'Wrote file',
    arguments: {
      op: 'write',
      path: '/infra/cloud-run-service.yaml',
      content: 'apiVersion: serving.knative.dev/v1\nkind: Service\n...',
    },
    result: { ok: true },
    status: 'ok',
    stepNarration: 'Cloud Run service manifest saved — deploying the FastAPI backend next.',
  },
  {
    durationMs: 5200,
    actionName: 'Wrote file',
    arguments: {
      op: 'write',
      path: '/infra/load-balancer.tf',
      content: 'resource "google_compute_global_forwarding_rule" "https" { ... }',
    },
    result: { ok: true },
    status: 'ok',
    stepNarration: 'Load balancer and Cloud Armor rules written to Terraform.',
  },
]

/** @param {{ streaming?: boolean }} [opts] */
